import React, { Component } from 'react';
import { PARSELY_SITE } from 'constants/vendor';
import { pageView } from './helper';

const SCRIPT_URL = `https://cdn.parsely.com/keys/${PARSELY_SITE}/p.js`;

// adapted from
// https://www.parse.ly/help/integration/dynamic#queueing-events-before-onload
const PARSELY_JS = `
  window.parselyPreload = window.parselyPreload || { eventQueue: [], loaded: false };
  window.PARSELY = window.PARSELY || {
    autotrack: false,
    onload: function() {
      parselyPreload.loaded = true;
      parselyPreload.eventQueue.forEach(function(e) {
        window.PARSELY.beacon.trackPageView(e);
      });
    }
  };
`;

class Parsely extends Component {
  static Head() {
    return <script dangerouslySetInnerHTML={{ __html: PARSELY_JS }} />;
  }
  static Body() {
    return <script defer id="parsely-cfg" src={SCRIPT_URL} />;
  }
  render() {
    return null;
  }
}

Parsely.pageView = pageView;

export default Parsely;
